import { compact } from 'lodash/fp';

export default (url, paramPairs = []) =>
  paramPairs.length > 0 ? `${url}${url.includes('?') ? '&' : '?'}${compact(paramPairs).join('&')}` : url;
